<script>
  import CartDropdownItemDisplay from '^/base/cart-dropdown-item-display'
  export default {
    name: "cart-dropdown-item-display",
    extends: CartDropdownItemDisplay,
  }
</script>
<style scoped>
  .product .product-image-area{
    min-height: 0;
    min-width: 0;
  }
</style>


// WEBPACK FOOTER //
// ixcms/themes/heartlandtan/src/vue-src/base/cart-dropdown-item-display.vue